import styled from "styled-components";

export const UploadPath = styled.div`
  width: auto;
  height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const Uploadhandler = styled.div`
  width: 184px;
  height: 173px;
  border: 1px dashed black;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  label {
    width: 73.6px;
    height: 69.2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  input {
    display: none;
  }
`;

export const UndoUpload = styled.div`
  width: 150px;
`;

export const UploadedImage = styled.div`
  width: 184px;
  height: 173px;
  border-radius: 8px;

  img {
    width: 100%;
    height: 173px;
    border-radius: 8px;
    object-fit: cover;
  }
`;
